import {
  Directive,
  OnInit,
  ComponentFactoryResolver,
  ViewContainerRef, HostBinding
} from "@angular/core";
import { BackButtonComponent } from "../../components/back-button/back-button.component";

@Directive({
  selector: "[tjBackButton]",
})
export class TjBackButtonDirective implements OnInit {

  @HostBinding('class') containerClass = 'backbutton-container';

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
    const factory =
      this.componentFactoryResolver.resolveComponentFactory(
        BackButtonComponent
      );
    const componentRef = this.viewContainerRef.createComponent(factory);
    componentRef.instance.onClick.subscribe(() => {
      window.history.back();
     
    });
  }
}
